import { BaseAuthService } from './BaseAuthService';
import { BACKEND_ROOT } from '../../config/host-config';
import { NotificationService } from '../../services';

export class EnumService extends BaseAuthService {
    private endpointRoot = `${BACKEND_ROOT}/api/enum`;
    private notificationService: NotificationService;

    constructor(notificationService: NotificationService) {
        super();
        this.notificationService = notificationService;
    }

    getEnums() {
        const endpoint = `${this.endpointRoot}`;

        const init = this.buildRequestInit('GET');

        return fetch(endpoint, init)
            .then((response) => {
                if (response.ok) {
                    return response.json();
                }

                const message = `Error retrieving enum data.`;
                this.notificationService.addError(message);
                throw new Error(message);
            });
    }
}


// WEBPACK FOOTER //
// ./src/services/api/EnumService.tsx